import { coachReviewToastKey } from './coachPresence';

export const startCoachReviewToast = (toasts = [], { eventId, coachName, hubOpen } = {}) => {
  const key = coachReviewToastKey(eventId);
  if (!key || hubOpen) return toasts;
  const existing = toasts.find(toast => toast.key === key);
  if (existing && !existing.typing) return toasts;
  const typingToast = {
    key,
    eventId: String(eventId),
    answer: '',
    coachName: coachName || null,
    typing: true,
    exiting: false,
  };
  return existing
    ? toasts.map(toast => toast.key === key ? { ...toast, ...typingToast } : toast)
    : [...toasts, typingToast];
};

export const completeCoachReviewToast = (toasts = [], { eventId, insightId, answer, coachName } = {}) => {
  const key = coachReviewToastKey(eventId);
  const text = String(answer || '').trim().slice(0, 800);
  if (!key || !text) return toasts;
  const readyToast = {
    key,
    eventId: String(eventId),
    answer: text,
    insightId: insightId ? String(insightId) : null,
    content: String(answer || '').trim(),
    coachName: coachName || null,
    typing: false,
    failed: false,
    persistent: false,
    exiting: false,
  };
  return toasts.some(toast => toast.key === key)
    ? toasts.map(toast => toast.key === key ? { ...toast, ...readyToast } : toast)
    : [...toasts, readyToast];
};

const fallbackActivityLabel = activityType => ({
  meal: 'this meal',
  workout: 'this workout',
  media: 'this upload',
  metric: 'this check-in',
}[String(activityType || '').toLowerCase()] || 'this activity');

export const coachReviewFailureFromTimelineMessage = (message = {}, coachName = null) => (
  message.state === 'failed'
    ? {
      eventId: message.eventId,
      coachName,
      activityName: message.activityName,
      activityType: message.activityType,
      errorCode: message.errorCode,
    }
    : null
);

export const failCoachReviewToast = (toasts = [], {
  eventId, coachName, activityName, activityType, errorCode,
} = {}) => {
  const key = coachReviewToastKey(eventId);
  if (!key) return toasts;
  const namedActivity = String(activityName || '').trim();
  const activityLabel = namedActivity || fallbackActivityLabel(activityType);
  const budgetReached = String(errorCode || '').toUpperCase() === 'INSUFFICIENT_LLM_CREDIT';
  const answer = budgetReached
    ? `Monthly AI budget reached. ${namedActivity ? `${activityLabel} wasn't` : `${activityLabel[0].toUpperCase()}${activityLabel.slice(1)} wasn't`} reviewed. Open Coach to retry.`
    : `Couldn't review ${activityLabel}. Open Coach to retry.`;
  const failedToast = {
    key,
    eventId: String(eventId),
    answer,
    coachName: coachName || null,
    typing: false,
    failed: true,
    persistent: true,
    errorCode: errorCode || null,
    exiting: false,
  };
  return toasts.some(toast => toast.key === key)
    ? toasts.map(toast => toast.key === key ? { ...toast, ...failedToast } : toast)
    : [...toasts, failedToast];
};

export const removeCoachReviewToast = (toasts = [], eventId) => {
  const key = coachReviewToastKey(eventId);
  return key ? toasts.filter(toast => toast.key !== key) : toasts;
};

export const markCoachReviewToastExiting = (toasts = [], eventId) => {
  const key = coachReviewToastKey(eventId);
  return key ? toasts.map(toast => toast.key === key ? { ...toast, exiting: true } : toast) : toasts;
};
